// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_SdQ","cls2":"LoswpTabsHero-cls2_NuL LoswpTabsHero-cls1_SdQ"};